<div class="body-wrapper" *ngIf="print.loaded" [ngClass]="Direction" style='padding-top: 0;'>
    <header class="header">
        <div class="justify-between items-center" [innerHtml]="altHeader" *ngIf="altHeader && showHeader"></div>
        <div class="justify-between items-center" *ngIf="print.env && print.env['haslogo'] && ! altHeader">
            <img style="width: 100%;" [src]="! print.env['haslogo'] ? '../../assets/images/logo.png' : '/api/logo'" alt="Logo">
        </div>
        <div class="justify-between items-center" style="margin-bottom: 5px;">
            <h1 class="header-title" style="width: max-content;font-size: 36px;">
                {{'exam.type.gastro.'+print.exam.ExamType | translate}}
                <span *ngIf="print.exam?.Draft">
                    ({{( 'general.DraftPrint') | translate}})
                </span>
            </h1>
            <!-- <img [src]="! print.env['haslogo'] ? '../../assets/images/logo.png' : '/api/logo'" alt="Logo"
                class="header-logo" *ngIf="print.env && ! altHeader && print.env['haslogo']"> -->
        </div>
        <div class="header-details" style="margin-bottom: 3em;">
            <div style="display: inline-block; padding-left: 1em;padding-right: 1em;font-size: 12pt;">{{(print.isForm ? 'general.date'
                :'general.ExaminationDate')| translate}}:&nbsp;<strong style='direction: ltr;'>{{print.exam.CreationTime
                    | date:"dd.MM.yyyy"}}</strong></div>
            <div style="display: inline-block;font-size: 12pt">
                {{'general.Printing_Date' | translate}}:&nbsp;
                <strong style='direction: ltr;'>
                    {{now | date:"dd.MM.yyyy HH:mm"}}
                </strong>
            </div>
        </div>
    </header>
    <main class="main" [ngClass]="typeOfPrint">
        <section class="section" *ngIf="print.Pat">
            <h4 class="text-20 text-gold">{{(print.Pat.Sex ? (print.Pat.Sex == 'M' ?  'gastro.Patient.male' : 'gastro.Patient.female'): 'gastro.Patient.details') | translate}}</h4>
            <div style="width:100%">
                <div>
                    <table>
                        <tr>
                            <td>
                                <dt>{{'general.Patient.first_name' | translate}}</dt>
                                <dd>{{print.Pat.First}}</dd>
                            </td>
                            <td>
                                <dt>{{'general.Patient.last_name' | translate}}</dt>
                                <dd>{{print.Pat.Last}}</dd>
                            </td>
                            <td>
                                <dt>{{'general.Patient.ID' | translate}}</dt>
                                <dd>{{print.Pat.ID}}</dd>
                            </td>
                            <td *ngIf="print.Pat.Mobile">
                                <dt>{{'general.Patient.mobile' | translate}}</dt>
                                <dd>{{print.Pat.Mobile}}</dd>
                            </td>
                            <td *ngIf="print.Pat.Sex">
                                <dt>מגדר</dt>
                                <dd>{{print.Pat.Sex == 'M'? 'גבר': 'אישה' }}</dd>
                            </td>
                        </tr>
                        <tr *ngIf="print.Pat.Height || print.Pat.Weight">
                            <td *ngIf="print.Pat.Birth">
                                <dt>{{'general.Patient.birth_date' | translate}}</dt>
                                <dd>{{print.Pat.Birth| date:"dd.MM.yyyy"}}</dd>
                            </td>
                            <td *ngIf="print.Pat.Birth">
                                <dt>{{'general.Patient.Age' | translate}}</dt>
                                <dd>{{print.Pat.getAgeMo()}}</dd>
                            </td>
                            <td *ngIf="print.Pat.Height">
                                <dt>גובה</dt>
                                <dd>{{print.Pat.Height}}cm</dd>
                            </td>
                            <td *ngIf="print.Pat.Weight">
                                <dt>משקל</dt>
                                <dd>{{print.Pat.Weight}}kg</dd>
                            </td>
                        </tr>
                    </table>

                    
                </div>
            </div>
        </section>
        
        <ng-container *ngIf="print.es.ExamType !== 'Abdomen US' && print.es.ExamType !== 'Hemorrhoids Treatment'">
        <!-- <ng-container *ngIf="true"> -->
        <section class="section" *ngIf="print.gastro && print.gastro[0] && print.gastro[0].TimeOut">
            <h4>{{'gastro.preparetion.TimeOut' | translate}}</h4>
            <p class="comment">{{print.gastro[0].TimeOut}}</p>
            <!-- <hr *ngIf="print.gastro[0] && (print.gastro[0].imag1 || print.gastro[0].imag2 || print.gastro[0].scope1 || print.gastro[0].scope2)" style="margin-top: 0.5em"> -->
            <!-- <div style="display: flex;">
                <td class="w-1/3" *ngIf="print.gastro[0] && (print.gastro[0].imag1 || print.gastro[0].imag2)" style="display: flex;"> <div><strong style="margin-inline-end: 1em;"> {{'gastro.preparetion.imagingDevice'| translate}}: </strong></div>  <div style="direction: ltr;display: flex;"> {{print.gastro[0].imag1}} <span *ngIf="print.gastro[0].imag1 && print.gastro[0].imag2"> # </span> {{print.gastro[0].imag2}}</div></td>
                <td class="w-1/3" *ngIf="print.gastro[0] && (print.gastro[0].scope1 || print.gastro[0].scope2)" style="display: flex;"> <div><strong style="margin-inline-end: 1em;"> {{'gastro.preparetion.scope'| translate}}: </strong> </div> <div style="direction: ltr;display: flex;"> {{print.gastro[0].scope1}} <span *ngIf="print.gastro[0].scope1 && print.gastro[0].scope2"> # </span> {{print.gastro[0].scope2}}</div></td>
            </div> -->
        </section>
        <section class="section" *ngIf="print.gastro && print.gastro[0] && (print.gastro[0].Reasone || print.gastro[0].ASA || print.gastro[0].Mellampeti || print.gastro[0].ReffDoc)">
            <section *ngIf="print.gastro[0] && (print.gastro[0].Reasone || print.gastro[0].ASA || print.gastro[0].Mellampeti)">
                <h4>{{'gastro.preparetion.Reasone' | translate}}</h4>
                <p class="comment">{{print.gastro[0].Reasone}}</p>
                <table *ngIf="print.gastro[0] && (print.gastro[0].ASA || print.gastro[0].Mellampeti)">
                    <tr>
                        <td *ngIf="print.gastro[0].ASA && print.gastro[0].ASA ">
                            <dt>דירוג ASA </dt>
                            <dd>{{print.gastro[0].ASA}}</dd>
                        </td>
                        <td *ngIf="print.gastro[0].Mellampeti ">
                            <dt>דירוג מלמפטי </dt>
                            <dd>{{print.gastro[0].Mellampeti}}</dd>
                        </td>
                    </tr>
                </table>
            </section>
        </section>
        <section class="section" *ngIf="print.Medication && print.Medication[0]">
            <h4>{{'gastro.preparetion.Medication' | translate}}</h4>
            <table class="l-table-auto medication-table">
                <tr class="l-row medication-thead">
                    <td class="l-td-m" style="width: 10%;">#</td>
                    <td class="l-td-m" style="width: 50%;">{{'gastro.preparetion.Medication_type' | translate}}</td>
                    <td class="l-td-m" style="width: 20%;">{{'gastro.preparetion.Unit' | translate}}</td>
                    <td class="l-td-m" style="width: 20%;">{{'gastro.preparetion.Dose' | translate}}</td>
                </tr>
                <ng-container *ngIf="print.Medication && print.Medication[0]">
                    <tr  class="l-row medication-tbody" *ngFor="let med of print.Medication[0]; index as i">
                        <td class="l-td-m" style="width: 10%;">{{i+1}}</td>
                        <td class="l-td-m" style="width: 50%;direction: ltr;">{{med.Medication}}</td>
                        <td class="l-td-m" style="width: 20%;">{{med.Dose}}</td>
                        <td class="l-td-m" style="width: 20%;">{{med.Unit}}</td>
                    </tr>
                </ng-container>
            </table>
        </section>
        <section class="section" *ngIf=" (print.gastro && print.gastro[0] ) &&(print.gastro[0].Preparetion || print.gastro[0].Comments || print.Medication)">
            <h4 class="text-20 text-gold">{{'gastro.preparetion.title' | translate}}</h4>
                <section class="section" *ngIf="print.gastro[0] && (print.gastro[0].Preparetion || print.gastro[0].BBPS || print.gastro[0].Quality)" style="width: 100%;">
                    <div class="comment">
                        <strong>פרוטוקול הכנה: </strong> {{print.gastro[0].Preparetion}}
                    </div>
                    <table *ngIf="print.es.ExamType !='Gastroscopy' && print.gastro[0] && (print.gastro[0].BBPS >-1)">
                        <tr>
                            <td>
                                <dt>דירוג הכנה לפי בוסטון</dt>
                                <dd>{{print.gastro[0].BBPS}}</dd>
                            </td>

                        </tr>
                    </table>
                    <table *ngIf="print.gastro[0].Quality">
                        <tr>
                            <td>
                                <dt>איכות ההכנה</dt>
                                <dd>{{'gastro.preparetion.Quality.'+print.gastro[0].Quality | translate}}</dd>
                            </td>

                        </tr>
                    </table>
                </section>
                <section class="section" *ngIf="print.gastro[0] && print.gastro[0].Comments">
                    <h4>{{'gastro.preparetion.Comments' | translate}}</h4>
                    <p class="comment">{{print.gastro[0].Comments}}</p>
                </section>
        </section>
        <!-- =========== Course of Exam (Start) =========== -->
        <section class="section" *ngIf="print.exam.printCourseOfExam && (print?.gastroProcedure || print?.signs?.[0])">
            <h3>{{'gastro.CourseOfExam.title' | translate}}</h3>
        
            <section class="section" *ngIf="print?.signs?.[0]">
                <h4>סימנים חיוניים</h4>
                <table class="l-table-auto weightAss-table">
                    <tr class="l-row weightAss-thead">
                        <td class="l-td-m" style="width: 5%;">#</td>
                        <td class="l-td-m" style="width: 15%;">שעה</td>
                        <td class="l-td-m" style="width: 15%;">לחץ דם</td>
                        <td class="l-td-m" style="width: 15%;">דופק</td>
                        <td class="l-td-m" style="width: 15%;">סטורציה</td>
                    </tr>
                    <ng-container *ngFor="let sign of print?.signs?.[0]; index as i">
                        <tr class="l-row weightAss-tbody">
                            <td class="l-td-m" style="width: 5%;">
                                {{i+1}}
                            </td>
                            <td class="l-td-m" style="width: 15%;">
                                {{sign?.CreationTime | date: 'HH:mm'}}
                            </td>
                            <td class="l-td-m" style="width: 15%;">
                                {{sign?.bpSystolic}}/{{sign?.bpDyastolic}}mmHg
                            </td>
                            <td class="l-td-m" style="width: 15%;">
                                {{sign?.Pulse}}bpm
                            </td>
                            <td class="l-td-m" style="width: 15%;">
                                {{sign?.Saturation}}%
                            </td>
                        </tr>
                    </ng-container>
                </table>
            </section>
            <section class="section" *ngIf="print?.gastroProcedure">
        
                <table class="l-table-auto">
                    <tr *ngFor="let procedure of print?.gastroProcedure; index as i">
                        <td *ngIf="procedure?.PainLevel">
                            <dt>
                                מדד כאב
                            </dt>
                            <dd>{{translatePainLevel(procedure?.PainLevel)}}</dd>
        
                        </td>
                        <td *ngIf="procedure?.Medication">
                            <dt>
                                סדציה
                            </dt>
                            <dd>{{procedure?.Medication}}</dd>
                        </td>
                        <td *ngIf="procedure?.Byopsy !== -1">
                            <dt>
                                ביופסיה
                            </dt>
                            <dd>{{procedure?.Byopsy ? 'כן' : 'לא' }}</dd>
                        </td>
                        <td *ngIf="procedure?.Plate !== -1">
                            <dt>
                                שימוש בפלטה
                            </dt>
                            <dd>{{procedure?.Plate ? 'כן' : 'לא' }}</dd>
                        </td>
                        <td *ngIf="procedure?.PlateText !== -1">
                            <dt>
                                מיקום הפלטה
                            </dt>
                            <dd>{{procedure?.PlateText}}</dd>
                        </td>
                        <td *ngIf="procedure?.OpenVein !== -1">
                            <dt>
                                למטופל וריד פתוח
                            </dt>
                            <dd>{{procedure?.OpenVein ? 'כן' : 'לא' }}</dd>
                        </td>
                        <td *ngIf="procedure?.SkinBefore !== -1">
                            <dt>
                                מצב העור לפני
                            </dt>
                            <dd>{{procedure?.SkinBefore ? 'תקין' : 'לא' }}</dd>
                        </td>
                        <td *ngIf="procedure?.SkinAfter !== -1">
                            <dt>
                                מצב העור אחרי
                            </dt>
                            <dd>{{procedure?.SkinAfter ? 'תקין' : 'לא' }}</dd>
                        </td>
                        <td *ngIf="procedure?.DuringProc !== -1">
                            <dt>
                                מהלך פעולה
                            </dt>
                            <dd>{{procedure?.DuringProc ? 'תקין' : 'לא' }}</dd>
                        </td>
                        <td *ngIf="procedure?.DuringProcText">
                            <dt>
                                פירוט
                            </dt>
                            <dd>{{procedure?.DuringProcText}}</dd>
                        </td>
                        <td *ngIf="procedure?.EndTime">
                            <dt>
                                שעת סיום הבדיקה
                            </dt>
                            <dd>{{procedure?.EndTime}}</dd>
                        </td>
                    </tr>
                </table>
            </section>
        
        </section>
        <!-- =========== Course of Exam (End) =========== -->
        <section class="section" *ngIf="print.gastro && print.gastro[0] && (print.gastro[0].Colonoscopy || print.gastro[0].FindingsComment || (print.gastro[0].DetailsFindings && print.gastro[0].DetailsFindings.length >0) || (print.gastro[0].Esophagus > -1 || print.gastro[0].EsophagusComment) || print.gastro[0].EsoJunction || (print.gastro[0].Stomach > -1 || print.gastro[0].StomachComment) || (print.gastro[0].Duodenum > -1 || print.gastro[0].DuodenumComment) || print.gastro[0].ColoComment || print.gastro[0].ExtentOfExam)">
            <!-- <h4 class="text-20 text-gold">{{'gastro.summary.title' | translate }}</h4> -->
            <section class="section" *ngIf="print.gastro[0] && print.gastro[0].ExtentOfExam">
                <h2>{{'gastro.preparetion.ExtentOfExam' | translate}}</h2>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].ExtentOfExam}}
                </div>
            </section>
            <section class="section">
                <h2>ממצאים</h2>
                <table *ngIf="print.exam.ExamType !== 'Gastroscopy'">
                    <tr *ngIf="print.gastro[0].Colonoscopy > -1">
                        <td>
                            {{(print.gastro[0].Colonoscopy == 1  ? '' : 'gastro.Findings.NPD') |
                            translate}}
                        </td>
                        <td *ngIf="print.gastro[0].Colonoscopy == 0 && print.gastro[0].FindingsComment">
                            <dt style="width: fit-content;">{{ 'gastro.preparetion.Comments' | translate}}</dt>
                            <dd>{{print.gastro[0].FindingsComment }}</dd>
                        </td>
                    </tr>
                    <tr *ngIf="print.gastro && print.gastro[0] && print.gastro[0].Annus">
                        <td>
                            <strong>{{'gastro.Findings.Anus' | translate}}</strong> {{print.gastro[0].Annus}}
                        </td>
                    </tr>
                    <ng-container *ngIf="print.gastro[0].Colonoscopy == 1">
                        <div *ngFor="let d of print.gastro[0].DetailsFindings;index as i">
                            <tr style="width: 100%;display: flex;">
                                <td style="width: 30%;display: flex;" *ngIf="d.value || d.value === 0 || d.value === 1 || d.comment">
                                    <div style="width: 50%;">
                                        <strong>{{'gastro.Findings.type.'+d.db | translate}}: </strong>
                                    </div>
                                    <div style="width:50%" *ngIf="d.value === 0 || d.value === 1">
                                        {{(d.value == 1 ? 'gastro.Findings.abnormal' : 'gastro.Findings.normal') | translate}}
                                    </div>
                                </td>
                                <td style="width: 70%;" *ngIf="d.comment">
                                    <strong>{{'gastro.preparetion.Comments' | translate}}:  </strong>
                                    {{d.comment}}
                                </td>
                            </tr>
                        </div>
                    </ng-container>
                </table>
                <table *ngIf="print.exam.ExamType == 'Gastroscopy'">
                    <tr *ngIf="print.gastro[0].Esophagus > -1 || print.gastro[0].EsophagusComment">
                        <td style="width: 10em;">
                            <dt style="width: 5em;">{{'gastro.Findings.Esophagus' | translate}}</dt>
                            <dd *ngIf="print.gastro[0].Esophagus > -1">{{(print.gastro[0].Esophagus == 1  ? 'gastro.Findings.abnormal' : 'gastro.Findings.normal') |
                                translate}}</dd>
                        </td>
                        <td *ngIf="print.gastro[0].EsophagusComment">
                            <dt>{{'gastro.preparetion.Comments' | translate}}</dt>
                            <dd>{{print.gastro[0].EsophagusComment}}</dd>
                        </td>
                    </tr>
                    <tr *ngIf="print.gastro[0].EsoJunction || print.gastro[0].EsoJunctionComment">
                        <td style="width: 15em;">
                            <dt>{{'gastro.Findings.EsoJunction' | translate}}</dt>
                            <dd *ngIf="print.gastro[0].EsoJunction">{{print.gastro[0].EsoJunction}}cm</dd>
                        </td>
                        <td *ngIf="print.gastro[0].EsoJunctionComment">
                            <dt>{{'gastro.preparetion.Comments' | translate}}</dt>
                            <dd>{{print.gastro[0].EsoJunctionComment}}</dd>
                        </td>
                    </tr>
                    <tr *ngIf="print.gastro[0].Stomach > -1 || print.gastro[0].StomachComment">
                        <td style="width: 10em;">
                            <dt style="width: 5em;">{{'gastro.Findings.Stomach' | translate}}</dt>
                            <dd *ngIf="print.gastro[0].Stomach > -1 ">{{(print.gastro[0].Stomach == 1  ? 'gastro.Findings.abnormal' : 'gastro.Findings.normal') |
                                translate}}</dd>
                        </td>
                        <td *ngIf="print.gastro[0].StomachComment">
                            <dt>{{'gastro.preparetion.Comments' | translate}}</dt>
                            <dd>{{print.gastro[0].StomachComment}}</dd>
                        </td>
                    </tr>
                    <tr *ngIf="print.gastro[0].Duodenum > -1 || print.gastro[0].DuodenumComment">
                        <td style="width: 10em;">
                            <dt style="width: 5em;">{{'gastro.Findings.Duodenum' | translate}}</dt>
                            <dd *ngIf="print.gastro[0].Duodenum > -1 ">{{(print.gastro[0].Duodenum == 1  ? 'gastro.Findings.abnormal' : 'gastro.Findings.normal') |
                                translate}}</dd>
                        </td>
                        <td *ngIf="print.gastro[0].DuodenumComment">
                            <dt>{{'gastro.preparetion.Comments' | translate}}</dt>
                            <dd>{{print.gastro[0].DuodenumComment}}</dd>
                        </td>
                    </tr>
                </table>
                <section class="section" *ngIf="print.gastro[0].ColoComment">
                    <h4>{{'gastro.preparetion.Comments' | translate}}</h4>
                    <p class="comment">{{print.gastro[0].ColoComment}}</p>
                </section>
            </section>
            <section class="section" *ngIf="(print.pathologyS.pathologies && print.pathologyS.pathologies.length > 0) ||(print.gastro[0] && print.gastro[0].PathologyComments)|| ( print.gastro[0].Hp || print.gastro[0].HpComment)">
                <h2>{{'gastro.Pathology.title' | translate}}</h2>
                <table class="l-table-auto weightAss-table" *ngIf="print.pathologyS.pathologies && print.pathologyS.pathologies.length > 0">
                    <tr class="l-row weightAss-thead">
                        <td class="l-td-m" style="width: 10%;">#</td>
                        <td class="l-td-m" style="width: 30%;">{{'gastro.Pathology.Type' | translate}}</td>
                        <td class="l-td-m" style="width: 60%;">{{'gastro.preparetion.Comments' | translate}}</td>
                    </tr>
                    <ng-container *ngFor="let p of print.pathologyS.pathologies;index as i">
                        <tr class="l-row weightAss-tbody">
                            <td class="l-td-m" style="width: 10%;">{{i+1}}</td>
                            <td class="l-td-m" style="width: 30%;">{{p.Type}}</td>
                            <td class="l-td-m" style="width: 60%;">{{p.Comments}}</td>
                        </tr>
                    </ng-container>
                </table>
                <h2 *ngIf="labReports.length > 0">תוצאות מעבדה</h2>
                <table class="l-table-auto weightAss-table" *ngIf="labReports.length > 0">
                    <tr class="l-row weightAss-thead">
                        <td class="l-td-m" style="width: 30%;">מעבדה</td>
                        <td class="l-td-m" style="width: 70%;">הערות לאחר בדיקות מעבדה</td>
                    </tr>
                    <ng-container *ngFor="let report of labReports">
                        <tr class="l-row weightAss-tbody">
                            <td class="l-td-m" style="width: 30%;">{{getLabName(report.Lab)}} {{report.ReceptionDate | date:"dd.MM.yyyy"}}</td>
                            <td class="l-td-m" style="width: 70%">
                                <p class="comment">
                                   {{report.DoctorNote}}
                                </p>
                            </td>
                        </tr>
                    </ng-container>
                </table>
                <section *ngIf="print.gastro[0] && (print.gastro[0].Hp || print.gastro[0].HpComment)" style="width: 100%;">
                    <div class="comment section-inner" style="width: 100%;display: flex;">
                        <h4 style="margin-left: 10px;">מבחן אוראז הליקובקטור פילורי:</h4>
                       <p  style="margin-left: 10px" *ngIf="print.gastro[0].Hp" class="comment">{{print.gastro[0].Hp=='positive'? 'חיובי':'שלילי'}}</p> 
                       <h4 style="margin-left: 10px" *ngIf="print.gastro[0].HpComment">{{'gastro.preparetion.Comments' | translate}}:</h4>
                       <p style="margin-left: 10px;" *ngIf="print.gastro[0].HpComment" class="comment">{{print.gastro[0].HpComment}}</p>

                    </div>
                </section>
                <section *ngIf="print.gastro[0] && print.gastro[0].PathologyComments" style="width: 100%;">
                    <div class="comment section-inner" style="width: 100%;">
                        <h4>{{'gastro.preparetion.Comments' | translate}}</h4>
                        {{print.gastro[0].PathologyComments}}
                    </div>
                </section>
                        </section>

            <section class="section" *ngIf="print.gastro[0] && (print.gastro[0].DiagnosisList?.length > 0 || print.gastro[0].Diagnosis)">
                <h2>{{'gastro.summary.diagnosisList' | translate}}</h2>
                <ng-container *ngIf="print.gastro[0].DiagnosisList" >
                    <table><tr *ngFor="let d of print.gastro[0].DiagnosisList">
                        <p class="comment" style="text-align: justify;">
                            {{d.value}}
                        </p>
                    </tr></table>
                </ng-container>
                <hr *ngIf="(print.gastro[0].DiagnosisList && print.gastro[0].DiagnosisList?.length > 0) && print.gastro[0].Diagnosis">
                <section *ngIf="print.gastro[0].Diagnosis" style="text-align: justify;">
                    <p class="comment">{{print.gastro[0].Diagnosis}}</p>
                </section>
            </section>
        </section>
        <ng-container>
            <section class="section" *ngIf="print.gastro && ((print.gastro[0] && print.gastro[0].Dissmission) || (print.gastro[0] && print.gastro[0].OtherStaff) ||(print.gastro[0] && print.gastro[0].Recomm) || (print.gastro[0] && print.gastro[0].Recovery)|| (print.gastro[0] && print.gastro[0].ReffDoc)|| (print.gastro[0] && print.gastro[0].HMO) || (print.gastro[0] && (print.gastro[0].imag1 || print.gastro[0].imag2 || print.gastro[0].scope1 || print.gastro[0].scope2)))">
                <h4 class="text-20 text-gold">התאוששות ושחרור</h4>
                <section class="section" *ngIf="print.gastro[0].Recovery">
                    <h4>{{'gastro.Recovery' | translate }}</h4>
                    <p class="comment" style="font-size: small;">{{print.gastro[0].Recovery}}</p>
                </section>
                <section class="section" *ngIf="print.gastro[0].Dissmission">
                    <h4>{{'gastro.Dissmission' | translate}}</h4>
                    <p class="comment" style="font-size: small;">{{print.gastro[0].Dissmission}}</p>
                </section>
                <section class="section" *ngIf="print.gastro[0].Recomm">
                    <h4>{{'gastro.Recomm' | translate }}</h4>
                    <p class="comment">{{print.gastro[0].Recomm}}</p>
                </section>
                <section *ngIf="print.gastro[0] && print.gastro[0].ReffDoc">
                    <strong>רופא מפנה: </strong> {{print.gastro[0].ReffDoc}}
                </section>
                <section *ngIf="print.gastro[0] && print.gastro[0].HMO">
                    <strong>גורם מפנה: </strong> {{print.gastro[0].HMO}}
                </section>
                <section *ngIf="print.gastro[0] && print.gastro[0].ProcedureResult">
                    <strong>ממצאי הבדיקה : </strong> {{print.gastro[0].ProcedureResult | translateresult}}
                </section>
                <section *ngIf="print.gastro[0] && print.gastro[0].OtherStaff">
                    <strong>שם האח\ות: </strong> {{print.gastro[0].OtherStaff}}
                </section>

            </section>
        </ng-container>
    </ng-container>
    <ng-container *ngIf="print.gastro && print.gastro[0] && print.es.ExamType === 'Hemorrhoids Treatment'">
        <section class="section">
            <section class="section" *ngIf="print.gastro[0].MedicalBackground">
                <h2>{{'GyneIntro.Medical_Background' | translate}}</h2>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].MedicalBackground}}
                </div>
            </section>
    
        </section>

        <section class="section" *ngIf="print.gastro && print.gastro[0] && print.gastro[0].TimeOut">
            <h4>{{'gastro.preparetion.TimeOut' | translate}}</h4>
            <p class="comment">{{print.gastro[0].TimeOut}}</p>
        </section>

        <section class="section" *ngIf="(print.gastro[0].DiagnosisList?.length > 0 || print.gastro[0].Diagnosis)">
            <h2>{{'gastro.summary.diagnosisList' | translate}}</h2>
            <ng-container *ngIf="print.gastro[0].DiagnosisList" >
                <table>
                    <tr *ngFor="let d of print.gastro[0].DiagnosisList">
                    <p class="comment" style="text-align: justify;">
                        {{d.value}}
                    </p>
                </tr>
            </table>
            </ng-container>
            <hr *ngIf="(print.gastro[0].DiagnosisList && print.gastro[0].DiagnosisList?.length > 0) && print.gastro[0].Diagnosis">
            <h4>{{'gastro.abdomen.Findings' | translate }}</h4>
            <section *ngIf="print.gastro[0].Diagnosis" style="text-align: justify;">
                <p class="comment">{{print.gastro[0].Diagnosis}}</p>
            </section>
        </section>


        <section class="section" *ngIf="print.gastro[0].Recovery">
            <h4>{{'gastro.Recovery' | translate }}</h4>
            <p class="comment" style="font-size: small;">{{print.gastro[0].Recovery}}</p>
        </section>
        <section class="section" *ngIf="print.gastro[0].Dissmission">
            <h4>{{'gastro.Dissmission' | translate}}</h4>
            <p class="comment" style="font-size: small;">{{print.gastro[0].Dissmission}}</p>
        </section>
        <section class="section" *ngIf="print.gastro[0].Recomm">
            <h4>{{'gastro.Recomm' | translate }}</h4>
            <p class="comment">{{print.gastro[0].Recomm}}</p>
        </section>

    </ng-container>
    <ng-container *ngIf="print.gastro && print.gastro[0] && print.es.ExamType === 'Abdomen US'">
        <section class="section">
            <section class="section" *ngIf="print.gastro[0].MedicalHistory">
                <h2>{{'GyneIntro.Medical_History' | translate}}</h2>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].MedicalHistory}}
                </div>
            </section>
            <section class="section" *ngIf="print.gastro[0].ReasonExamination">
                <h2>{{'gastro.preparetion.Reasone' | translate}}</h2>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].ReasonExamination}}
                </div>
            </section>
        </section>
        <section class="section">
            <h4 class="text-20 text-gold">{{'gastro.Findings.title' | translate }}</h4>
    
            <section class="section" *ngIf=" print.gastro[0].Liver">
                <h4>{{'gastro.abdomen.Liver' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].Liver}}
                </div>
            </section>
            <section class="section" *ngIf=" print.gastro[0].Gallbladder">
                <h4>{{'gastro.abdomen.Gallbladder' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].Gallbladder}}
                </div>
            </section>
            <section class="section" *ngIf=" print.gastro[0].BiliaryTract">
                <h4>{{'gastro.abdomen.BiliaryTract' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].BiliaryTract}}
                </div>
            </section>
            <section class="section" *ngIf=" print.gastro[0].Pancreas">
                <h4>{{'gastro.abdomen.Pancreas' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].Pancreas}}
                </div>
            </section>
            <section class="section" *ngIf=" print.gastro[0].Intestine">
                <h4>{{'gastro.abdomen.Intestine' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].Intestine}}
                </div>
            </section>
            <section class="section" *ngIf="print.gastro[0].RetroPeritoneum">
                <h4>{{'gastro.abdomen.RetroPeritoneum' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].RetroPeritoneum}}
                </div>
            </section>
            <section class="section" *ngIf="print.gastro[0].Spleen">
                <h4>{{'gastro.abdomen.Spleen' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].Spleen}}
                </div>
            </section>
            <section class="section" *ngIf="print.gastro[0].AbdominalAorta">
                <h4>{{'gastro.abdomen.AbdominalAorta' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].AbdominalAorta}}
                </div>
            </section>
            <section class="section" *ngIf="print.gastro[0].Kidneys">
                <h4>{{'gastro.abdomen.Kidneys' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].Kidneys}}
                </div>
            </section>
            <section class="section" *ngIf="print.gastro[0].Bladder">
                <h4>{{'gastro.abdomen.Bladder' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].Bladder}}
                </div>
            </section>
            <section class="section" *ngIf="print.gastro[0].Prostate">
                <h4>{{'gastro.abdomen.Prostate' | translate}}</h4>
                <div style="white-space: pre-wrap;">
                    {{print.gastro[0].Prostate}}
                </div>
            </section>

        </section>
        <section class="section" *ngIf="(print.gastro[0].DiagnosisList?.length > 0 || print.gastro[0].Diagnosis)">
            <h2>{{'gastro.summary.diagnosisList' | translate}}</h2>
            <ng-container *ngIf="print.gastro[0].DiagnosisList" >
                <table>
                    <tr *ngFor="let d of print.gastro[0].DiagnosisList">
                    <p class="comment" style="text-align: justify;">
                        {{d.value}}
                    </p>
                </tr>
            </table>
            </ng-container>
            <hr *ngIf="(print.gastro[0].DiagnosisList && print.gastro[0].DiagnosisList?.length > 0) && print.gastro[0].Diagnosis">
            <h4>{{'gastro.abdomen.Findings' | translate }}</h4>
            <section *ngIf="print.gastro[0].Diagnosis" style="text-align: justify;">
                <p class="comment">{{print.gastro[0].Diagnosis}}</p>
            </section>
        </section>


        <section class="section" *ngIf="print.gastro[0].Summary">
            <div class="comment section-inner" style="display: inherit">
                <h4>{{'summary.title' | translate}}: </h4>
                <br>
                <span [innerHtml]="print.gastro[0].Summary">
                </span>
            </div>
        
        </section>

    </ng-container>
        <section *ngIf="print.es.ExamType !== 'Abdomen US'" class="section">
            <h4>
מסמך זה מהווה הפניה רפואית למיון                    
            </h4>
        </section>

    <!-- =============== Exam Signature (Start) =============== -->
    <ng-container *ngIf="!print.exam.Draft">
        <section class="section">
            <table>
                <tr *ngFor="let signer of print.signers;let i = index" style="vertical-align: top;">
                    <td class="w-1/3">
                        <strong>{{(signer['Title'] ? signer['Title']+ ' ': '')+ signer.Name}}</strong>
                        <img *ngIf="signer['signatureUrl']" [src]="signer['signatureUrl']" style='max-height: 60px; vertical-align: middle; margin-inline-start: 10px;'>
                        <img *ngIf="!signer['signatureUrl'] && signer['signature']" [src]="'assets/signatures/'+signer['signature']" style='max-height: 60px; vertical-align: middle; margin-inline-start: 10px;'>
                    </td>
                    <td class="w-1/3">
                        @if (signer.DrNum) {מ.ר. <strong>{{signer.DrNum}} </strong>}
                        @if (signer.ExpertNum) {מ.ר.מ. <strong>{{signer.ExpertNum}}</strong>}
                        @if (signer.NurseNum) { {{ 'summary.doctor.licensenumber' | translate }} <strong>{{signer.NurseNum}}</strong> }
                        @if (signer.TechNum) { {{ 'summary.doctor.licensenumber' | translate }} <strong>{{signer.TechNum}}</strong> }
                    </td>
                    <td class="w-1/3" *ngIf="i == 0">{{(print.isForm ? 'general.date' :'general.ExaminationDate') |
                        translate}}: <strong>{{print.exam.CreationTime | date:"dd.MM.yyyy"}}</strong></td>
                </tr>
            </table>
        </section>
        
    </ng-container>
    <!-- =============== Exam Signature (End) =============== -->

        <div *ngIf="hasImages && print.images.length > 0" class="signatures" [ngClass]="'perpage'+imPerPage">
            <ng-container *ngFor="let image of print.images">
                <div style="width: fit-content;display: inline-flex;flex-direction: column;">
                    <img style="padding: 0.5em;" [src]="'/api/getmedia/'+image.src+'/n'">
                    <p *ngIf="image.text" class="section" style="width: 95%;margin-inline-start: 0.5em;" [ngClass]="imPerPage ==2 ? 'w100' :'w95'">{{image.text}}</p>
                </div>
            </ng-container>
        </div>
        <span class="comment" class="finished" *ngIf="loaded"></span>
    </main>
</div>